import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initializeApp } from './shared/services/initializeApp'
import { AppProviders } from './app/providers'

// Import dev utils for development mode
if (process.env.NODE_ENV === 'development') {
  import('./shared/services/utils/devUtils');
  import('./shared/services/testAppSettings');
}

// Register service worker for Firebase Cloud Messaging
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        // Firebase SW registered
      })
      .catch((registrationError) => {
        // Firebase SW registration failed
      });
  });
}

// Initialize app settings before rendering
initializeApp().then(() => {
  createRoot(document.getElementById('root')!).render(
    <AppProviders>
      <App />
    </AppProviders>,
  )
}).catch(() => {
  // Fallback: render app even if settings fail to load
  createRoot(document.getElementById('root')!).render(
    <AppProviders>
      <App />
    </AppProviders>,
  )
})
